module.exports = __webpack_public_path__ + "media/images/desktop2/GettyImages-1239808798.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/desktop2/GettyImages-1239808798.jpeg
// module id = 27
// module chunks = 0